import Vue from "vue";
import Router from "vue-router";
import Empresas from "@/components/empresas/Empresas.vue";
import NotAllowed from "@/components/core/NotAllowed.vue";
import Login from "@/components/core/Login.vue";
import Perfil from "@/components/core/Perfil.vue";
import Landing from "@/components/core/Landing.vue";
import Dashboard from "@/components/dashboard/Dashboard.vue";
import Users from "@/components/admin/Users.vue";
import AddUser from "@/components/admin/AddUser.vue";
import EditUser from "@/components/admin/EditUser.vue";
import Politicas from "@/components/core/Politicas.vue";
import Contactenos from "@/components/core/Contactenos.vue";
import Registrar from "@/components/registrar/Registrar.vue";
import Imprimir from "@/components/prints/Imprimir.vue";
import Creainforme from "@/components/informes/Crea.vue";
import Listplantilla from "@/components/informes/Listplantilla.vue";
import Carpetalist from "@/components/informes/Listinformes.vue";
import View from "@/components/informes/View.vue";
import Listview from "@/components/informes/Listview.vue";
import Logout from "@/components/core/Logout.vue";
import Settings from "@/components/settings/Settings.vue";
import Settingspvta from "@/components/settings/pventa/Settingspventa.vue";
import Reports from "@/components/reports/Reports.vue";
import Accountbalance from "@/components/reports/accountbalance/Accountbalance.vue";
import Accountbalancebeta from "@/components/reports/accountbalance/Accountbalancebeta.vue";
import Auxiliar from "@/components/reports/auxiliar/Auxiliar.vue";
import Fraelectlist from "@/components/reports/fraelectronica/Fraelectronicalist.vue";
import Viewshare from "@/components/informes/Viewshare.vue";
import Configurations from "@/components/configurations/Configurations.vue";
import Chartaccounts from "@/components/configurations/chartaccounts/Chartaccounts.vue";
import Document from "@/components/configurations/document/Document.vue";
import Documentcreate from "@/components/configurations/document/Documentcreate.vue";
import Cuentadocument from "@/components/configurations/document/Cuentadocumento.vue";
import Months from "@/components/configurations/months/Months.vue";
import Commercialmonth from "@/components/configurations/commercialmonth/Commertialmonth.vue";
import Costcenter from "@/components/configurations/costcenter/Costcenter.vue";
import Inventorygroup from "@/components/configurations/inventorygroup/Inventorygroup.vue";
import Cellar from "@/components/configurations/cellar/Cellar.vue";
import Measurementunits from "@/components/configurations/measurementunits/Measurementunits.vue";
import Registros from "@/components/admin/registros/Registros.vue";
import DeleteRegisters from "@/components/admin/registros/DeleteRegisters.vue";
import AddSellers from "@/components/admin/addsellers/Addsellers.vue";
import Empresa from "@/components/configurations/empresa/Empresa.vue";
import Seller from "@/components/configurations/seller/Seller.vue";
import Accountinglines from "@/components/configurations/accountinglines/Accountinglines.vue";
import Terceros from "@/components/configurations/terceros/Terceros.vue";
import Account from "@/components/configurations/accounts/Account.vue";
import Accountcreate from "@/components/configurations/accounts/Accountcreate.vue";
import Repgrafica from "@/components/reports/fraelectronica/Repgrafica.vue";
import Products from "@/components/configurations/products/Products.vue";
import Facturar from "@/components/facturar/Facturar.vue";
import Registrarcontador from "@/components/registrarcontador/Registrarcontador.vue";
import Inventario from "@/components/reports/inventario/Inventario.vue";
import Upload from "@/components/upload/Upload.vue";
import Inventory from "@/components/admin/inventory/Inventory.vue";
import Nuevafactura from "@/components/facturar/Nuevafactura.vue";
import Comisiones from "@/components/comisiones/Comision.vue";
import Edades from "@/components/comisiones/Edades.vue";
import Vendedores from "@/components/comisiones/Vendedores.vue";
import Clientes from "@/components/comisiones/Clientes.vue";
import Cartera from "@/components/comisiones/Cartera.vue";
import ComisionProductos from "@/components/comisiones/Productos.vue";
import Rcomisiones from "@/components/comisiones/Comisiones.vue";
import Configuracionnomina from "@/components/nomina/Configuracion.vue";
import Configuracionempleados from "@/components/nomina/empleados/Empleados.vue";
import Devengados from "@/components/nomina/devengados/Devengados.vue";
import Habilitacion from "@/components/admin/habilitacion/Habilitacion.vue";
import Editproducto from "@/components/admin/editproducto/Editproducto.vue";
import Creaplanilla from "@/components/nomina/planilla/Creaplanilla.vue";
import Planilla from "@/components/nomina/Planilla.vue";
import Detalleplanilla from "@/components/nomina/planilla/Detalleplanilla.vue";
import UploadExcelnomina from "@/components/nomina/UploadExcel.vue";
import Documents from "@/components/admin/documents/Documents.vue";
import Cierremenu from "@/components/cierre/Cierremenu.vue";
import Cierreyear from "@/components/cierre/year/Cierreyear.vue";
import Cierrecuenta from "@/components/cierre/cuenta/Cierrecuenta.vue";
import Iva from "@/components/reports/iva/Iva.vue";
import NewEmpresa from "@/components/admin/empresa/NewEmpresa.vue";
import Configprojects from "@/components/proyectos/configuracion/Configuracion.vue";
import Projectsprojects from "@/components/proyectos/configuracion/Proyectos.vue";
import ProjectsEmpresas from "@/components/proyectos/configuracion/Empresas.vue";
// import Tickets from "@/components/proyectos/tickets/Tickets.vue";
// import Newticket from "@/components/proyectos/tickets/NewTicket.vue";
import Listticket from "@/components/proyectos/tickets/ListTicket.vue";
import MenuTask from "@/components/proyectos/task/MenuTask.vue";
import Task from "@/components/proyectos/task/Task.vue";
import ReportTask from "@/components/proyectos/reports/Reporttask.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    redirect: to => {
      return {
        name: "landing",
        meta: {
          isPublic: true
        }
      };
    }
  },
  {
    path: "/landing",
    name: "landing",
    component: Landing,
    meta: {
      isPublic: true
    }
  },
  {
    path: "/nuevafactura",
    component: Nuevafactura,
    name: "nuevafactura",
    menu: {
      section: "Beta",
      icon: "point_of_sale",
      title: "Factura y NC",
      scope: ["admin", "contador", "auxiliar"]
    },
    meta: {
      isAuthenticated: true
    }
  },

  {
    path: "/home",
    component: Dashboard,
    name: "home",
    menu: {
      section: "Inicio",
      icon: "dashboard",
      title: "Indicadores",
      scope: ["admin", "contador", "gerente", "auxiliar"]
    },
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/viewprincipal",
    component: View,
    name: "viewprincipal",
    menu: {
      section: "Inicio",
      icon: "chrome_reader_mode",
      title: "Último Informe",
      scope: ["admin", "contador", "gerente", "auxiliar"]
    },
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/listview",
    component: Listview,
    name: "listview",
    menu: {
      section: "Inicio",
      icon: "list",
      title: "Informes",
      scope: ["admin", "contador", "gerente", "auxiliar"]
    },
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/reports",
    component: Reports,
    name: "reports",
    menu: {
      section: "Inicio",
      icon: "list_alt",
      title: "Reportes",
      scope: ["admin", "contador", "auxiliar", "vendedor"]
    },
    meta: {
      isAuthenticated: true
    },
    children: [
      {
        path: "/reports/iva",
        component: Iva,
        name: "reports.iva",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/reports/auxiliar",
        component: Auxiliar,
        name: "reports.auxiliar",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/reports/inventario",
        component: Inventario,
        name: "reports.inventario",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/reports/accountbalance",
        component: Accountbalance,
        name: "reports.accountbalance",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/reports/accountbalancebeta",
        component: Accountbalancebeta,
        name: "reports.accountbalancebeta",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/reports/fraelectlist",
        component: Fraelectlist,
        name: "reports.fraelectlist",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/reports/repgrafica/:id",
        component: Repgrafica,
        name: "reports.repgrafica",
        meta: {
          isAuthenticated: true
        }
      }
    ]
  },
  {
    path: "/listview/:id",
    component: View,
    name: "listviewid",
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/notAllowed",
    component: NotAllowed,
    name: "notAllowed",
    meta: {
      isPublic: true
    }
  },
  {
    path: "/facturar",
    component: Facturar,
    name: "registro",
    menu: {
      section: "Comercial",
      icon: "point_of_sale",
      title: "Factura y NC",
      scope: ["admin", "contador", "auxiliar"]
    },
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/registro",
    component: Registrar,
    name: "facturar",
    menu: {
      section: "Comercial",
      icon: "assignment",
      title: "Registrar",
      scope: ["admin", "contador", "auxiliar"]
    },
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/comercialimprimir",
    component: Imprimir,
    name: "comercialimprimir",
    menu: {
      section: "Comercial",
      icon: "print",
      title: "Imprimir",
      scope: ["admin", "contador", "auxiliar"]
    },
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/settings",
    component: Settings,
    name: "settings",
    menu: {
      section: "Comercial",
      icon: "settings",
      title: "Preferencias",
      scope: ["admin", "contador", "auxiliar"]
    },
    meta: {
      isAuthenticated: true
    },
    children: [
      {
        path: "/settings/pventa",
        component: Settingspvta,
        name: "settings.pventa",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/settings/terceros",
        component: Terceros,
        name: "settings.terceros",
        meta: {
          isAuthenticated: true
        }
      }
    ]
  },
  {
    path: "/contadorregistrar",
    component: Registrarcontador,
    name: "contadorregistrar",
    menu: {
      section: "Contador",
      icon: "assignment",
      title: "Registrar",
      scope: ["contador"]
    },
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/upload",
    component: Upload,
    name: "upload",
    menu: {
      section: "Contador",
      icon: "cloud_upload",
      title: "Importar",
      scope: ["contador"]
    },
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/contadorcreainforme",
    component: Creainforme,
    name: "contadorcreainforme",
    menu: {
      section: "Contador",
      icon: "note_add",
      title: "Crear Informe",
      scope: ["contador"]
    },
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/plantillalist",
    component: Listplantilla,
    name: "plantillalist",
    menu: {
      section: "Contador",
      icon: "assignment",
      title: "Plantillas",
      scope: ["contador"]
    },
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/plantillalist/:tipo/:id",
    component: Creainforme,
    name: "editinforme",
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/carpetaslist",
    component: Carpetalist,
    name: "carpetaslist",
    menu: {
      section: "Contador",
      icon: "description",
      title: "Informes",
      scope: ["contador"]
    },
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/carpetaslist/:tipo/:id",
    component: Creainforme,
    name: "editinforme1",
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/configurations",
    component: Configurations,
    name: "configurations",
    menu: {
      section: "Contador",
      icon: "settings",
      title: "Configuración",
      scope: ["admin", "contador"]
    },
    meta: {
      isAuthenticated: true
    },
    children: [
      {
        path: "/configurations/chartaccounts",
        component: Chartaccounts,
        name: "configurations.chartaccounts",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/document",
        component: Document,
        name: "configurations.document",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/documentcreate",
        component: Documentcreate,
        name: "configurations.documentcreate",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/documentedit/:id",
        component: Documentcreate,
        name: "configurations.documentedit",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/cuentadocument/:comprobanteid",
        component: Cuentadocument,
        name: "configurations.cuentadocument",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/costcenter",
        component: Costcenter,
        name: "configurations.costcenter",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/months",
        component: Months,
        name: "configurations.months",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/commercialmonth",
        component: Commercialmonth,
        name: "configurations.commercialmonth",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/inventorygroup",
        component: Inventorygroup,
        name: "configurations.inventorygroup",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/cellar",
        component: Cellar,
        name: "configurations.cellar",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/measurementunits",
        component: Measurementunits,
        name: "configurations.measurementunits",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/empresa",
        component: Empresa,
        name: "configurations.empresa",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/seller",
        component: Seller,
        name: "configurations.seller",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/accountinglines",
        component: Accountinglines,
        name: "configurations.accountinglines",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/terceros",
        component: Terceros,
        name: "configurations.terceros",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/account",
        component: Account,
        name: "configurations.account",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/accountcreate",
        component: Accountcreate,
        name: "configurations.accountcreate",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/accountedit/:id",
        component: Accountcreate,
        name: "configurations.accountedit",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configurations/products",
        component: Products,
        name: "configurations.products",
        meta: {
          isAuthenticated: true
        }
      }
    ]
  },
  {
    path: "/cierre",
    component: Cierremenu,
    name: "cierre",
    menu: {
      section: "Contador",
      icon: "check_circle_outline",
      title: "Cierre",
      scope: ["admin", "contador"]
    },
    meta: {
      isAuthenticated: true
    },
    children: [
      {
        path: "/cierre/year",
        component: Cierreyear,
        name: "cierre.year",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/cierre/cuenta",
        component: Cierrecuenta,
        name: "cierre.cuenta",
        meta: {
          isAuthenticated: true
        }
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      isPublic: true
    }
  },
  {
    path: "/perfil",
    name: "perfil",
    component: Perfil,
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/empresas",
    component: Empresas,
    name: "empresas",
    meta: {
      isAuthenticated: true
    }
  },

  // **************** MODULO COMISIONES
  {
    path: "/comisiones",
    component: Comisiones,
    menu: {
      section: "Comisiones",
      icon: "request_page",
      title: "Comisiones",
      scope: ["comision"]
    },
    name: "comision",
    meta: {
      isAuthenticated: true
    },
    children: [
      {
        path: "/comisiones/edades",
        component: Edades,
        name: "comision.edades",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/comisiones/vendedores",
        component: Vendedores,
        name: "comision.vendedores",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/comisiones/clientes",
        component: Clientes,
        name: "comision.clientes",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/comisiones/producto",
        component: ComisionProductos,
        name: "comision.producto",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/comisiones/cartera",
        component: Cartera,
        name: "comision.cartera",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/comisiones/comisiones",
        component: Rcomisiones,
        name: "comision.comisiones",
        meta: {
          isAuthenticated: true
        }
      }
    ]
  },
  // ****************** RUTAS NOMINA
  {
    path: "/nominaconfiguracion",
    component: Configuracionnomina,
    name: "nominaconfiguracion",
    menu: {
      section: "Nomina",
      icon: "miscellaneous_services",
      title: "Configuración",
      scope: ["admin", "nomina"]
    },
    meta: {
      isAuthenticated: true
    },
    children: [
      {
        path: "/nominaconfiguracion/empleados",
        component: Configuracionempleados,
        name: "nominaconfiguracion.empleados",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/nominaconfiguracion/devengados",
        component: Devengados,
        name: "nominaconfiguracion.devengados",
        meta: {
          isAuthenticated: true
        }
      }
    ]
  },

  {
    path: "/planillanomina",
    component: Planilla,
    name: "planillanomina",
    menu: {
      section: "Nomina",
      icon: "home_repair_service",
      title: "Planilla",
      scope: ["admin"]
    },
    meta: {
      isAuthenticated: true
    },
    children: [
      {
        path: "/planillanomina/title",
        component: Creaplanilla,
        name: "planillanomina.title",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/planillanomina/planilladetalle/:planillaid",
        component: Detalleplanilla,
        name: "planillanomina.detalle",
        meta: {
          isAuthenticated: true
        }
      }
    ]
  },
  {
    path: "/nominaupload",
    component: UploadExcelnomina,
    name: "nominaupload",
    menu: {
      section: "Nomina",
      icon: "file_upload",
      title: "Subir Excel",
      scope: ["admin", "nomina"]
    },
    meta: {
      isAuthenticated: true
    }
  },

  // ****************** MODULO ADMIN

  {
    path: "/users",
    component: Users,
    menu: {
      section: "Admin",
      icon: "group",
      title: "Usuarios",
      scope: ["admin"]
    },
    name: "users",
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/adduser",
    component: AddUser,
    menu: {
      section: "Admin",
      icon: "person_add",
      title: "Crear Usuario",
      scope: ["admin"]
    },
    name: "adduser",
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/adminregistros",
    component: Registros,
    menu: {
      section: "Admin",
      icon: "ballot",
      title: "Utilidades",
      scope: ["admin"]
    },
    name: "adminregistros",
    meta: {
      isAuthenticated: true
    },
    children: [
      {
        path: "/adminregistros/delete",
        component: DeleteRegisters,
        name: "adminregistros.delete",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/adminregistros/addseller",
        component: AddSellers,
        name: "adminregistros.addsellers",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/adminregistros/inventory",
        component: Inventory,
        name: "adminregistros.inventory",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/adminregistros/documents",
        component: Documents,
        name: "adminregistros.documents",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/adminregistros/habilitacion",
        component: Habilitacion,
        name: "adminregistros.habilitacion",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/adminregistros/editproducto",
        component: Editproducto,
        name: "adminregistros.editproducto",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/adminregistros/newempresa",
        component: NewEmpresa,
        name: "adminregistros.newempresa",
        meta: {
          isAuthenticated: true
        }
      }
    ]
  },
  {
    path: "/users/edit/:id",
    component: EditUser,
    name: "edituser",
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/logout",
    name: "logout",
    component: Logout,
    meta: {
      isAuthenticated: true
    }
  },
  {
    path: "/politicas",
    name: "politicas",
    component: Politicas,
    meta: {
      isPublic: true
    }
  },
  {
    path: "/contactenos",
    name: "contactenos",
    component: Contactenos,
    meta: {
      isPublic: true
    }
  },
  {
    path: "/share/:id",
    component: Viewshare,
    name: "shareid",
    meta: {
      isPublic: true
    }
  },
  {
    path: "/configprojects",
    component: Configprojects,
    menu: {
      section: "Proyectos",
      icon: "settings",
      title: "Configuración",
      scope: ["admin"]
    },
    name: "configprojects",
    meta: {
      isAuthenticated: true
    },
    children: [
      {
        path: "/configprojects/projects",
        component: Projectsprojects,
        name: "configprojects.projects",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/configprojects/empresas",
        component: ProjectsEmpresas,
        name: "configprojects.empresas",
        meta: {
          isAuthenticated: true
        }
      }
    ]
  },
  // {
  //   path: "/tickets",
  //   component: Tickets,
  //   menu: {
  //     section: "Proyectos",
  //     icon: "support",
  //     title: "Tickets",
  //     scope: ["proyectos"]
  //   },
  //   name: "tickets",
  //   meta: {
  //     isAuthenticated: true
  //   },
  //   children: [
  //     {
  //       path: "/tickets/new",
  //       component: Newticket,
  //       name: "tickets.new",
  //       meta: {
  //         isAuthenticated: true
  //       }
  //     },
  //     {
  //       path: "/tickets/list",
  //       component: Listticket,
  //       name: "tickets.list",
  //       meta: {
  //         isAuthenticated: true
  //       }
  //     },
  //     {
  //       path: "/tickets/edit/:id",
  //       component: Newticket,
  //       name: "tickets.edit",
  //       meta: {
  //         isAuthenticated: true
  //       }
  //     }
  //   ]
  // },
  {
    path: "/task",
    component: MenuTask,
    menu: {
      section: "Proyectos",
      icon: "fact_check",
      title: "Tareas",
      scope: ["admin", "cande"]
    },
    name: "task",
    meta: {
      isAuthenticated: true
    },
    children: [
      {
        path: "/task/list",
        component: Task,
        name: "task.list",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/task/ticketlist",
        component: Listticket,
        name: "task.ticketlist",
        meta: {
          isAuthenticated: true
        }
      },
      {
        path: "/task/reports",
        component: ReportTask,
        name: "task.reports",
        meta: {
          isAuthenticated: true
        }
      }
    ]
  },
  // Default
  {
    path: "*",
    redirect: "/landing"
  }
];

const router = new Router({
  routes,
  mode: "history"
});

router.beforeEach((to, from, next) => {
  let loggedin = localStorage.getItem("loggedin");
  loggedin = JSON.parse(loggedin);
  if (to.matched.some(record => record.meta.isAuthenticated)) {
    if (!loggedin) {
      next("landing");
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/routes/index.js